var _path, _circle, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFilterApplied(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4.565 3C3.701 3 3 3.713 3 4.59v.936c0 .65.247 1.276.69 1.746l4.845 5.152.002-.003A5.157 5.157 0 0110 16.023v4.572c0 .306.32.5.585.357l2.76-1.504c.416-.228.676-.67.676-1.15v-2.287c0-1.342.519-2.631 1.446-3.587l4.846-5.152c.44-.47.688-1.096.688-1.746V4.59C21 3.713 20.3 3 19.436 3H4.566z",
    stroke: "#ED1B2E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8,
    cy: 16.8,
    r: 4.8,
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.158 19.2a.466.466 0 01-.335-.142l-1.284-1.315a.493.493 0 010-.685.465.465 0 01.67 0l.95.972 2.233-2.288a.465.465 0 01.67 0 .493.493 0 010 .686l-2.569 2.63a.466.466 0 01-.335.142z",
    fill: "#fff"
  })));
}

export default SvgIconFilterApplied;